import React from "react";
import { IconCheveronLeft, IconCheveronRight } from "../../icons/Icon";
import { COLOR_PRIMARY } from "../../constants/colors";

function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];

  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}

const SmuPaginator = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage,
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    pages > 1 && 
    <div className={`smu-pagination mt-auto`}>
      <ul className="pagination my-3 ms-auto">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            <IconCheveronLeft color={COLOR_PRIMARY} />
          </button>
        </li>

        {pageItems.map((page) => (
          <li
            key={page}
            className={`page-item ${page === currentPage ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={handlePageNumber}
              value={page}
            >
              {page}
            </button>
          </li>
        ))}

        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            <IconCheveronRight color={COLOR_PRIMARY} />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default SmuPaginator;
